import Update from '@/views/Update.vue';
import Items from '@/views/Items.vue';
import Item from '@/views/Item.vue';
import ItemContent from '@/views/ItemContent.vue';
import Registration from '@/views/Registration.vue';
import Products from '@/views/Products.vue';
import Doses from '@/views/Doses.vue';
import Drugs from '@/views/Drugs.vue';
import References from '@/views/References.vue';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Ddx from '@/views/Ddx.vue';
import RedirectView from '@/views/RedirectView.vue';
import DrugsInteractions from '@/views/DrugsInteractions.vue';
import Account from '@/views/Account.vue';
import FlashcardsMenu from '@/views/FlashcardsMenu.vue';
import ClinicalHandouts from "@/views/ClinicalHandouts.vue";
import ClinicalHandoutsContent from "@/views/ClinicalHandoutsContent.vue";
import PatientRecord from "@/views/PatientRecord.vue";
import Prescriptions from "@/views/Prescriptions.vue";
import EncounterDetail from "@/views/EncounterDetail.vue";
import PrescriptionsSummary from "@/views/PrescriptionsSummary.vue";
import AIConversations from "@/views/AIConversations.vue";
import AIConversation from "@/views/AIConversation.vue";

let routes = [
    {
        path: "/",
        view: 'Update',
        component: Update,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: true,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Atualizar'
        }
    },
    {
        path: "/redirect/*",
        view: 'RedirectView',
        component: RedirectView,
        meta: {
            scrolling: false,
            allowCopy: false,
            publicPage: true,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Redirecionar'
        }
    },
    {
        path: "/login",
        view: 'Login',
        component: Login,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: true,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Login'
        }
    },
    {
        path: "/home",
        view: 'Home',
        component: Home,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Início',
            backgroundColor: 'white'
        }
    },
    {
        path: "/items",
        view: 'Items',
        component: Items,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Buscar',
            backgroundColor: 'secondary'
        }
    },
    {
        path: "/items/:mode",
        view: 'ItemsMode',
        component: Items,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Buscar',
            backgroundColor: 'secondary'
        }
    },
    {
        path: "/topics/:topic",
        view: 'ItemsTopics',
        component: Items,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Buscar',
            backgroundColor: 'secondary'
        }
    },
    {
        path: "/categories/:category/drugs/:id",
        view: 'Drugs',
        component: Drugs,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true,
            ptName: 'Medicamentos',
            favorites: true,
        }
    },
    {
        path: "/categories/:category/drugs/:id/doses/:dose",
        view: 'Doses',
        component: Doses,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true,
            ptName: 'Doses'
        }
    },
    {
        path: "/ddx",
        view: 'Ddx',
        component: Ddx,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: false,
            ptName: 'Diagnósticos Diferenciais'
        }
    },
    {
        path: "/accounts",
        view: 'Accounts',
        component: Account,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: false,
            ptName: 'Meus Dados'
        }
    },
    {
        path: "/drugs/interactions",
        view: 'DrugsInteractions',
        component: DrugsInteractions,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: false,
            ptName: 'Interações Medicamentosas'
        }
    },
    {
        path: "/categories/:category/products/:id",
        view: 'Products',
        component: Products,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true,
            ptName: 'Produtos',
            favorites: true,
        }
    },
    {
        path: "/item/:id",
        view: 'Item',
        component: Item,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true,
            ptName: 'Conteúdo',
            favorites: true,
        }
    },
    {
        path: "/item/:itemId/content/:contentIndex/section/:sectionIndex",
        view: 'ItemContent',
        component: ItemContent,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true,
            ptName: 'Conteúdo Detalhado',
            favorites: true,
        }
    },
    {
        path: "/cards",
        view: 'FlashcardsMenu',
        component: FlashcardsMenu,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Flashcards',
            favorites: false,
        }
    },
    {
        path: "/registration",
        view: 'Registration',
        component: Registration,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: true,
            collapseHeaderOnScroll: false,
            statusBarColor: 'white',
            hideStatusBar: false,
            avoidBreadcrumb: true,
            ptName: 'Registro'
        }
    },
    {
        path: "/registration/:field",
        view: 'RegistrationField',
        component: Registration,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: true,
            collapseHeaderOnScroll: false,
            statusBarColor: 'white',
            hideStatusBar: false,
            avoidBreadcrumb: true,
            ptName: 'Registro'
        }
    },
    {
        path: "/references",
        view: 'References',
        component: References,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true,
            ptName: 'Referências'
        }
    },
    {
        path: "/calculators/:id",
        view: 'Calculators',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/Calculators.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: false,
            ptName: 'Calculadoras',
            favorites: true,
        }
    },
    {
        path: "/calculators/continuous-infusion/custom",
        view: 'ContinuousInfusionCalculator',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/ContinuousInfusionCalculator.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: false,
            ptName: 'Calculadoras',
            favorites: true,
        }
    },
    {
        path: "/calculators/transfusion-volume-speed/custom",
        view: 'TransfusionVolumeSpeedCalculator',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/TransfusionVolumeSpeedCalculator.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: false,
            ptName: 'Calculadoras',
            favorites: true,
        }
    },
    {
        path: "/calculators/dose/custom",
        view: 'DoseCalculator',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/DoseCalculator.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: false,
            ptName: 'Calculadoras',
            favorites: true,
        }
    },
    {
        path: "/calculators/rule-of-three/custom",
        view: 'RuleOfThreeCalculator',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/RuleOfThreeCalculator.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: false,
            ptName: 'Calculadoras',
            favorites: true,
        }
    },
    {
        path: "/calculators/drops-to-volume/custom",
        view: 'DropsToVolume',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/DropsToVolumeCalculator.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: false,
            ptName: 'Calculadoras',
            favorites: true,
        }
    },
    {
        path: "/checkouts",
        view: 'Checkouts',
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Checkouts'
        }
    },
    {
        path: "/subscriptions",
        view: 'Subscriptions',
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Assinaturas'
        }
    },
    {
        path: "/handouts",
        view: 'ClinicalHandouts',
        component: ClinicalHandouts,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Folhetos do Tutor'
        }
    },
    {
        path: "/prescriptions",
        view: 'Prescriptions',
        component: Prescriptions,
        meta: { scrolling: true, allowCopy: false, publicPage: false, collapseHeaderOnScroll: false, statusBarColor: 'black', hideStatusBar: true, ptName: 'Prescrições' }
    },
    {
        path: "/prescriptions/:id/edit",
        view: 'PrescriptionsEdit',
        component: Prescriptions,
        meta: { scrolling: true, allowCopy: false, publicPage: false, collapseHeaderOnScroll: false, statusBarColor: 'black', hideStatusBar: true, ptName: 'Editar prescrição' }
    },
    {
        path: "/patients",
        view: 'Patients',
        component: PatientRecord,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Prontuário'
        }
    },
    {
        path: "/patients/:patientId/record",
        view: 'PatientRecord',
        component: PatientRecord,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Prontuário'
        }
    },
    {
        path: "/patients/:patientId/encounters/:encounterId",
        view: 'EncounterDetail',
        component: EncounterDetail,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Consulta'
        }
    },
    {
        path: "/prescriptions/:id",
        view: 'PrescriptionsSummary',
        component: PrescriptionsSummary,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Prescrições',
            allowZoom: true,
        }
    },
    {
        path: "/handouts/:id",
        view: 'ClinicalHandoutsContent',
        component: ClinicalHandoutsContent,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Folhetos do Tutor'
        }
    },
    {
        path: "/ai-conversations",
        view: 'AIConversations',
        component: AIConversations,
        meta: {
            scrolling: true,
            allowCopy: true,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Conversas',
            backgroundColor: 'secondary'
        }
    },
    {
        path: "/ai-conversations/:id",
        view: 'AIConversation',
        component: AIConversation,
        meta: {
            scrolling: true,
            allowCopy: true,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true,
            ptName: 'Conversa',
            backgroundColor: 'secondary'
        }
    },
];
if (process.env.VUE_APP_ENV === 'admin') {
    routes = [
        {
            path: "/",
            view: 'TopicsManagement',
            component: () => import(/* webpackChunkName: "management" */ '@/views/TopicsManagement.vue'),
            meta: {
                scrolling: true,
                allowCopy: true,
                publicPage: true,
                collapseHeaderOnScroll: true,
                statusBarColor: 'black',
                hideStatusBar: true
            }
        },
        {
            path: "/categories",
            view: 'DrugsManagement',
            component: () => import(/* webpackChunkName: "management" */ '@/views/DrugsManagement.vue'),
            meta: {
                scrolling: true,
                allowCopy: true,
                publicPage: true,
                collapseHeaderOnScroll: true,
                statusBarColor: 'black',
                hideStatusBar: true
            }
        },
        {
            path: "/customers",
            view: 'CustomersManagement',
            component: () => import(/* webpackChunkName: "management" */ '@/views/CustomersManagement.vue'),
            meta: {
                scrolling: true,
                allowCopy: true,
                publicPage: true,
                collapseHeaderOnScroll: true,
                statusBarColor: 'black',
                hideStatusBar: true
            }
        },
        {
            path: "/item/:id",
            view: 'Item',
            component: Item,
            meta: {
                scrolling: true,
                allowCopy: true,
                publicPage: true,
                collapseHeaderOnScroll: true,
                statusBarColor: 'black',
                hideStatusBar: true
            }
        }
    ];
} else if (process.env.VUE_APP_ENV === 'owners') {
    routes = [
        {
            path: "/:id",
            view: 'Owners',
            component: () => import(/* webpackChunkName: "owners" */ '@/owners/Owners.vue'),
            meta: {
                scrolling: true,
                allowCopy: true,
                publicPage: true,
                collapseHeaderOnScroll: true,
                statusBarColor: 'black',
                hideStatusBar: true
            }
        },
        {
            path: "/",
            view: 'OwnersWelcome',
            component: () => import(/* webpackChunkName: "owners" */ '@/owners/Owners.vue'),
            meta: {
                scrolling: true,
                allowCopy: true,
                publicPage: true,
                collapseHeaderOnScroll: true,
                statusBarColor: 'black',
                hideStatusBar: true
            }
        },
    ]
}

export default routes;
